/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_Raw_Materials_prepare_ingestion_draft } from "../models/Body_Raw_Materials_prepare_ingestion_draft";
import type { Body_Raw_Materials_upload_raw_material_document } from "../models/Body_Raw_Materials_upload_raw_material_document";
import type { BooleanResponse } from "../models/BooleanResponse";
import type { PaginatedResponse_list_definitions_public_v1_raw_materials_RawMaterial__ } from "../models/PaginatedResponse_list_definitions_public_v1_raw_materials_RawMaterial__";
import type { PaginatedResponse_list_definitions_public_v1_raw_materials_RawMaterialOption__ } from "../models/PaginatedResponse_list_definitions_public_v1_raw_materials_RawMaterialOption__";
import type { RawMaterialDocumentBulkUpdateRequest } from "../models/RawMaterialDocumentBulkUpdateRequest";
import type { Response_list_definitions_public_v1_document_Document__ } from "../models/Response_list_definitions_public_v1_document_Document__";
import type { Response_list_definitions_public_v1_raw_materials_IngestionDraftRawMaterial__ } from "../models/Response_list_definitions_public_v1_raw_materials_IngestionDraftRawMaterial__";
import type { Response_RawMaterialDetail_ } from "../models/Response_RawMaterialDetail_";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class RawMaterialsService {
  /**
   * Search Raw Materials
   * @param qs A search term to filter raw materials by
   * @param limit The maximum number of raw materials to return
   * @param offset The number of raw materials to skip
   * @returns PaginatedResponse_list_definitions_public_v1_raw_materials_RawMaterialOption__ Successful Response
   * @throws ApiError
   */
  public static rawMaterialsSearchRawMaterials(
    qs: string,
    limit: number = 10,
    offset?: number
  ): CancelablePromise<PaginatedResponse_list_definitions_public_v1_raw_materials_RawMaterialOption__> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/raw-materials/search",
      query: {
        qs: qs,
        limit: limit,
        offset: offset,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * List Popular Raw Materials
   * @param limit The maximum number of raw materials to return
   * @param offset The number of raw materials to skip
   * @returns PaginatedResponse_list_definitions_public_v1_raw_materials_RawMaterial__ Successful Response
   * @throws ApiError
   */
  public static rawMaterialsListPopularRawMaterials(
    limit: number = 10,
    offset?: number
  ): CancelablePromise<PaginatedResponse_list_definitions_public_v1_raw_materials_RawMaterial__> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/raw-materials/popular",
      query: {
        limit: limit,
        offset: offset,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * List Raw Material Documents
   * @param rawMaterialId
   * @returns Response_list_definitions_public_v1_document_Document__ Successful Response
   * @throws ApiError
   */
  public static rawMaterialsListRawMaterialDocuments(
    rawMaterialId: string
  ): CancelablePromise<Response_list_definitions_public_v1_document_Document__> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/raw-materials/{raw_material_id}/documents",
      path: {
        raw_material_id: rawMaterialId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Upload Raw Material Document
   * @param rawMaterialId
   * @param formData
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static rawMaterialsUploadRawMaterialDocument(
    rawMaterialId: string,
    formData: Body_Raw_Materials_upload_raw_material_document
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/raw-materials/{raw_material_id}/documents",
      path: {
        raw_material_id: rawMaterialId,
      },
      formData: formData,
      mediaType: "multipart/form-data",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Raw Material Documents
   * @param rawMaterialId
   * @param requestBody
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static rawMaterialsUpdateRawMaterialDocuments(
    rawMaterialId: string,
    requestBody: RawMaterialDocumentBulkUpdateRequest
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/raw-materials/{raw_material_id}/documents",
      path: {
        raw_material_id: rawMaterialId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Raw Material Detail
   * @param rawMaterialId
   * @returns Response_RawMaterialDetail_ Successful Response
   * @throws ApiError
   */
  public static rawMaterialsGetRawMaterialDetail(
    rawMaterialId: string
  ): CancelablePromise<Response_RawMaterialDetail_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/raw-materials/{raw_material_id}",
      path: {
        raw_material_id: rawMaterialId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Prepare Ingestion Draft
   * @param formData
   * @returns Response_list_definitions_public_v1_raw_materials_IngestionDraftRawMaterial__ Successful Response
   * @throws ApiError
   */
  public static rawMaterialsPrepareIngestionDraft(
    formData: Body_Raw_Materials_prepare_ingestion_draft
  ): CancelablePromise<Response_list_definitions_public_v1_raw_materials_IngestionDraftRawMaterial__> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/raw-materials/ingestions",
      formData: formData,
      mediaType: "multipart/form-data",
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
